"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importStar(require("react"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const resources_1 = require("../../helper/resources");
const IotPage = () => {
    (0, react_1.useEffect)(() => {
        document.title = (0, translation_1.t)('portal_subpage_title', { title: (0, translation_1.t)('iot.page_title') });
    }, []);
    (0, react_1.useEffect)(() => {
        if (!FRONTEND_IOT_COMPONENT_SCRIPT) {
            return;
        }
        (0, resources_1.addResourcesToDom)(FRONTEND_IOT_COMPONENT_SCRIPT);
    }, []);
    return (react_1.default.createElement("div", { className: "znd-webcomponent" }, react_1.default.createElement(__APP__.FRONTEND_IOT_COMPONENT_TAG, {}, [react_1.default.createElement(LoadingSpinner_1.default, { center: true, key: 0 })])));
};
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.CONNECT_READ })(IotPage));
